module.exports = __webpack_public_path__ + "img/LSV-Logo.d7bca968.svg";